import PropTypes from 'prop-types';
import ExpandableSection from '../../../../../atoms/ExpandableSection';
import ReliabilityChart from './ReliabilityChart';
import DisplacementRatesChart from './DisplacementRatesChart';
import './style.scss';

const ZonesCharts = ({feature}) => {
	return (
		<div className="insar-ZonesCharts">
			<ExpandableSection title="Zones charts">
				<div className="insar-ZonesCharts-charts">
					<ReliabilityChart feature={feature} />
					<DisplacementRatesChart feature={feature} />
				</div>
			</ExpandableSection>
		</div>
	);
};

ZonesCharts.propTypes = {
	feature: PropTypes.object,
};

export default ZonesCharts;
